import React, { useEffect } from "react";
import { useTrackContext } from "../../../hooks/useTrackContext";
import { getAdminIdFromStoreFrontId } from "../../../helpers/shopify";

interface IProps {
  title: "10" | "20" | "50";
  variantId: string;
  isVariantOutOfStock: boolean;
  price: number;
}

const ArcadeGame: React.FC<IProps> = ({ title, price, variantId, isVariantOutOfStock }) => {
  const { arcadeSelection, dispatch } = useTrackContext();

  const isActive = arcadeSelection.arcadeGameChoose.selectedArcadeGame === title;

  useEffect(() => {
    if (title === "10") {
      dispatch({
        type: "SET_ARCADE_GAME_SELECTION",
        payload: {
          selectedVariantId: variantId,
          isProductOutOfStock: isVariantOutOfStock,
          arcadeGameSelection: title,
        },
      });
    }
  }, [dispatch, isVariantOutOfStock, title, variantId]);

  const handleArcadeGameChoose = (title: "10" | "20" | "50") => {
    dispatch({
      type: "SET_ARCADE_GAME_SELECTION",
      payload: {
        selectedVariantId: variantId,
        isProductOutOfStock: isVariantOutOfStock,
        arcadeGameSelection: title,
      },
    });
  };

  return (
    <div>
      <div
        className={`tw-rounded-[25px] tw-w-fit tw-overflow-hidden hover:tw-cursor-pointer tw-mx-auto`}
        style={
          isActive
            ? {
                padding: "4px",
                background: "linear-gradient(282.87deg,#f908ff 6.14%,#d32efe 14.09%,#37ccfb 91.49%,#05fffa 103.26%)",
              }
            : {
                padding: "4px",
                background: "transparent",
              }
        }
        data-variant-id={getAdminIdFromStoreFrontId(variantId as string)}
        id="mcp-selector-variant"
        onClick={() => handleArcadeGameChoose(title)}
      >
        <div className={`tw-h-full tw-w-full tw-rounded-[22px]`}>
          <div className={`tw-flex tw-items-center tw-justify-center tw-py-[40px] tw-px-[60px] tw-relative ${isActive ? "tw-bg-[#2F1160]" : "tw-bg-[#393B41]"} tw-rounded-[22px]`}>
            <span className={`hover:tw-cursor-text ${isActive ? "tw-text-white" : "tw-text-[#C2C0C3]"}`}>
              <div className="tw-text-center">
                <p className="tw-font-bold tw-text-[64px]">{title}</p>
                <p className="tw-text-[24px] tw-font-[600] tw-mt-[-20px]">Games</p>
                <p className="tw-text-[30px] tw-font-[700] tw-flex tw-gap-[10px] tw-justify-center">
                  {title === "20" && <span className="tw-line-through">$50</span>}
                  {title === "50" && <span className="tw-line-through">$125</span>}
                  <span className="tw-bg-clip-text tw-text-transparent tw-bg-gradient-to-r tw-from-[#05FFFA] tw-to-[#F908FF]">${Number(price).toFixed(0)}</span>
                </p>
                {title === "10" && <p className="tw-font-[700] tw-text-center tw-mt-2 tw-invisible tw-opacity-0">10% off $2.25 per game</p>}
                {title === "20" && <p className="tw-font-[700] tw-text-center tw-mt-2">10% off $2.25 per game</p>}
                {title === "50" && <p className="tw-font-[700] tw-text-center tw-mt-2">20% off $2 per game</p>}
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArcadeGame;
